import { render } from "./MutualSettlementsView.vue?vue&type=template&id=d7adf4a4&scoped=true"
import script from "./MutualSettlementsView.vue?vue&type=script&lang=js"
export * from "./MutualSettlementsView.vue?vue&type=script&lang=js"

import "./MutualSettlementsView.vue?vue&type=style&index=0&id=d7adf4a4&scoped=true&lang=css"
import "./MutualSettlementsView.vue?vue&type=style&index=1&id=d7adf4a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7adf4a4"]])

export default __exports__